import { scoreToModifier, type StatId } from '@/schemas/stats';
import { STAT_META, formatModifier } from '@/utils/statMeta';
import { cn } from '@/lib/utils';

// molecule — DWR sheet stat: display di una caratteristica con valore + mod.
// Riusato 6 volte in <FullSheet> (FOR/DES/COS/INT/SAG/CAR).
// Pattern .sheet-stat mockup (styles.css righe 1818-1847): abbreviazione + value
// grande Cinzel + modificatore + nome stat italic.
// Variant `bumped`: indica una stat alzata da level-up (bg paper-soft + badge ↑).

interface SheetStatProps {
  statId: StatId;
  /** Punteggio corrente del PG (post level-up se applicabile). */
  value: number;
  /** Punteggio base (pre level-up). Se diverso da value → bumped. */
  baseValue?: number | undefined;
  className?: string;
}

export function SheetStat({ statId, value, baseValue, className }: SheetStatProps) {
  const meta = STAT_META[statId];
  const bumped = baseValue !== undefined && baseValue !== value;
  return (
    <div
      className={cn(
        'border-ink bg-paper relative flex flex-col gap-[0.1rem] border px-[0.6rem] py-[0.5rem]',
        bumped && 'bg-paper-soft',
        className,
      )}
    >
      <div className="font-display text-ink-soft text-[0.7rem] tracking-[0.1em] uppercase">
        {meta.abbr}
      </div>
      <div className="font-display flex items-baseline gap-1 text-[1.6rem] font-bold">
        {value}
        {bumped ? (
          <span
            className="bg-ink text-paper-bright px-1 text-[0.7rem]"
            title={`Aumentata da ${baseValue} a ${value}`}
          >
            ↑
          </span>
        ) : null}
      </div>
      <div className="text-ink-soft text-[0.85rem]">{formatModifier(scoreToModifier(value))}</div>
      <div className="text-ink-faint text-[0.72rem] italic">{meta.name}</div>
    </div>
  );
}
